import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth, AuthRole } from '../contexts/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRole?: AuthRole;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, requiredRole }) => {
  const { isAuthenticated, authRole, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen bg-slate-50">
        <div className="flex flex-col items-center gap-3">
          <div className="w-8 h-8 border-4 border-indigo-600 border-t-transparent rounded-full animate-spin" />
          <p className="text-sm text-slate-500">Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (requiredRole === 'admin' && authRole !== 'admin' && authRole !== 'super_admin') {
    return <Navigate to="/portal" replace />;
  }

  if (requiredRole === 'super_admin' && authRole !== 'super_admin') {
    return <Navigate to="/portal" replace />;
  }

  return <>{children}</>;
};
